import React from 'react';
import { HeroSectionV2 } from '../components/HeroSectionV2';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { BonusSection } from '../components/BonusSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPageV3() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-1186">
      <HeroSectionV2 data-id="element-1187" />
      <PainSection data-id="element-1188" />
      <TruthSection data-id="element-1189" />
      <ProductPresentation data-id="element-1190" />
      <ContentBreakdown data-id="element-1191" />
      <BenefitsSection data-id="element-1192" />
      <TestimonialsSection data-id="element-1193" />
      <ForYouSection data-id="element-1194" />
      <GuaranteeSection data-id="element-1195" />
      <BonusSection data-id="element-1196" />
      <ValueStack data-id="element-1197" />
      <FAQSection data-id="element-1198" />
      <ImpactPhrases data-id="element-1199" />
      <Footer data-id="element-1200" />
    </div>;
}